import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useSpeechSynthesis } from "react-speech-kit";

// import Container from "@mui/material/Container";
// import MenuItem from "@mui/material/MenuItem";
// import AppBar from "@mui/material/AppBar";
// import InputLabel from "@mui/material/InputLabel";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";

export default function SpeechSynthesis() {
  const { speak } = useSpeechSynthesis();
  let [msg, setMsg] = useState("Hello World");
  let [rate, setRate] = useState(1);
  let [volume, setVolume] = useState(1);
  let [pitch, setPitch] = useState(1);
  //let [voice, setVoice] = useState("");
  function Speaker() {
    speak({
      text: msg.length > 0 ? msg : "Please Write Something",
      rate: rate,
      pitch: pitch,
      volume: volume,
    });
  }
  function handleRateChange(e) {
    setRate(e.target.value);
  }
  function handlePitchChange(e) {
    setPitch(e.target.value);
  }
  function handleVolumeChange(e) {
    setVolume(e.target.value);
  }
  //   function handleVoiceChange(e) {
  //     console.log(e.target.value);
  //     setVoice(e.target.value);
  //   }
  function handleChange(e) {
    setMsg(e.target.value);
  }
  function handleKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      Speaker();
    }
  }

  return (
    <>
      <Typography sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
        Rate
      </Typography>
      <Slider
        step={0.25}
        min={0.25}
        max={2}
        value={rate}
        onChange={handleRateChange}
        valueLabelDisplay="auto"
      />
      <Typography sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
        Pitch
      </Typography>
      <Slider
        step={0.2}
        min={0}
        max={2}
        value={pitch}
        onChange={handlePitchChange}
        valueLabelDisplay="auto"
      />
      <Typography sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
        Volume
      </Typography>
      <Slider
        step={0.1}
        min={0}
        max={1}
        value={volume}
        onChange={handleVolumeChange}
        valueLabelDisplay="auto"
      />
      <TextField
        id="outlined-multiline-static"
        label="Message"
        multiline
        rows={5}
        value={msg}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        sx={{ mb: 3, mt: 5 }}
        fullWidth
      />
      {/* <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Voice</InputLabel>
          <Select label="Voice" value={voice} onChange={handleVoiceChange}>
            {voices.map(function (voice, index) {
              console.log("hey");
              return <MenuItem value={index}>{voice.name}</MenuItem>;
            })}
          </Select>
        </FormControl> */}
      <Button variant="contained" size="large" onClick={Speaker}>
        Speak
      </Button>
    </>
  );
}
